import { BaseMicroAppPlugin } from '../core/BaseMicroAppPlugin'
import { IMicroAppData } from '../core/types'

export class ConsoleLoggerPlugin extends BaseMicroAppPlugin {
  enabled = false
  constructor() {
    super('console-logger', 'Micro App Console Logger')
  }

  onMount(data: IMicroAppData): void {
    if (!this.enabled) return
    console.log(`[DEBUG] [MicroApps] 🚀 [${data.appName}] Mounted ${data.filePath}`)
  }

  onUnmount(data: IMicroAppData): void {
    if (!this.enabled) return
    console.log(`[DEBUG] [MicroApps] 🔽 [${data.appName}] Unmounted ${data.filePath}`)
  }
}
